import { memo } from 'react';

const AuthFormPanel = memo(({ children }) => (
  <div className="mx-auto flex min-h-dvh w-full max-w-auth-form flex-1 flex-col items-center gap-2.25 desktop:gap-3 p-page lg:mx-0 lg:min-h-0">
    {children}
  </div>
));

AuthFormPanel.displayName = 'AuthFormPanel';

export default AuthFormPanel;
